import React, { SetStateAction } from "react";
import { DropDownButton } from "../../../../components/ui/Buttons";
import Label from "../../../../components/form/Label";
import useConvertToTime from "../../../../hooks/useConvertToTime";
import { UserActivityDataTypes } from "../../../../types/user-activity-data-types";
import typeBasedTileColor from "../../constants/typeBasedTileColor";
import { userActivityDisplayLabel } from "../../../../types/user-activity";
import {useTimeZoneSelectContext} from "../../../../providers/TimeZoneSelectProvider";
import moment from "moment";
import {useAuth} from "@/context/user";

function UserInformation({
  setDropDown,
  dropDown,
  userData,
}: {
  setDropDown: React.Dispatch<SetStateAction<boolean>>;
  dropDown: boolean;
  userData: UserActivityDataTypes;
}) {
  const tileColor = typeBasedTileColor(userData.type)!;
  // const time = useConvertToTime(userData.timestamp);
  const tzContext = useTimeZoneSelectContext()

  const time = moment.tz(userData.timestamp, tzContext.timeZone)

  const type = userData.type.replace("_", " ");
  const { borderColor } = tileColor!;
  const sourceLabel = userData.source === "app_sms" ? "App - SMS" : userData.source;
  const {isSuperAdmin} = useAuth();


  return (
    <div
      className={`relative text-sm w-full h-fit p-8 bg-white flex flex-col rounded-xl text-grey border-4 
      border-${borderColor} border-opacity-25`}
    >
      <span className="font-semibold">{userData.metadata.deviceName}</span>
      <span className="font-semibold">
      {userData.metadata.deviceName && userData.metadata.userName ?
          <span className="font-semibold">User: </span>
          : null
        }
        {userData.metadata.userName}</span>
      {isSuperAdmin && <span className="">{userData.metadata.clientName}</span>}
      <span className="mr-5">
        {userData.metadata.departmentName ?
          <span className="font-semibold">Dept: </span>
          : null
        }
          {userData.metadata.departmentName}</span>
      <div className=" mt-2 capitalize">
        <Label text="Time sent:" assignText={time.format("HH:mm:ss Z z")} />
        <Label
          text="Type:"
          assignText={userActivityDisplayLabel(userData)}
          extraClass="capitalize"
        />
        <Label text="Source:" assignText={sourceLabel} />
      </div>
      <DropDownButton open={dropDown} onClick={() => setDropDown(!dropDown)} />
    </div>
  );
}

export default UserInformation;
